"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ArrowButtonDown = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/52-Arrows-Diagrams/01-Arrows/ArrowButtonDown"));
var _TopNav = require("../TopNav.style");
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var clearFocus = function clearFocus(index) {
  var activeFocus = document.activeElement;
  if (activeFocus.parentElement.getAttribute('data-index') != index) {
    activeFocus.parentElement.classList.remove('focus');
    activeFocus.blur();
  }
};
var DropDown = function DropDown(_ref) {
  var children = _ref.children,
    className = _ref.className,
    icon = _ref.icon,
    index = _ref.index,
    isDark = _ref.isDark,
    link = _ref.link,
    onFocus = _ref.onFocus;
  return /*#__PURE__*/_react.default.createElement(_TopNav.NavItem, {
    "aria-haspopup": "true",
    isDark: isDark,
    className: className,
    "data-key": "max-desktop-navigation__nav-item-".concat(index, "--dropdown"),
    "data-index": index,
    onMouseEnter: function onMouseEnter() {
      return clearFocus(index);
    }
  }, /*#__PURE__*/_react.default.createElement(_TopNav.NavButton, {
    onFocus: onFocus,
    isDark: isDark
  }, icon && /*#__PURE__*/_react.default.createElement(_TopNav.DropDownIcon, null, icon), /*#__PURE__*/_react.default.createElement("span", null, link.label), /*#__PURE__*/_react.default.createElement(_spacer.default, {
    size: "xxs"
  }, /*#__PURE__*/_react.default.createElement(_ArrowButtonDown.default, {
    size: "xxs",
    color: isDark ? 'brand02' : 'brand03'
  }))), /*#__PURE__*/_react.default.createElement(_TopNav.DropDownBox, null, children));
};
var _default = DropDown;
exports.default = _default;